import React from "react";
import styles from "./WizardDesignTemplateItem.module.scss";
import { IDesignTemplate } from "../../../../../../modules/EditDesignTemplate/utils/designTemplates";
import { Link } from "react-router-dom";
import { GeneratorSitePreview } from "../../../../../GeneratorSite/GeneratorSitePreview";
import { GeneratorSitePreviewScaleSetter } from "../../../../../GeneratorSite/components/GeneratorSitePreviewScaleSetter/GeneratorSitePreviewScaleSetter";

interface IProps {
    designTemplate: IDesignTemplate;
    setDesignTemplate: (designTemplate: IDesignTemplate) => void;
    selectedDesignTemplate?: IDesignTemplate;
    calculateScale: boolean;
}

export const WizardDesignTemplateItem = (props: IProps) => {
    return (
        <Link
            to={"/kom-igang/information"}
            className={`${styles.wrapper} ${
                props.selectedDesignTemplate === props.designTemplate ? styles.active : ""
            }`}
            onClick={() => props.setDesignTemplate(props.designTemplate)}
            data-test-id={"design-template-selector-" + props.designTemplate?.name}
            data-test-design-template-name={props.designTemplate?.name}
        >
            {props.calculateScale ? (
                <GeneratorSitePreviewScaleSetter scaleCssVariableName="--site-preview-scale-edit-design-template" />
            ) : null}
            <GeneratorSitePreview
                designTemplate={props.designTemplate}
                scaleCssVariableName="--site-preview-scale-edit-design-template"
            />
        </Link>
    );
};
